module.exports = __webpack_public_path__ + "static/media/bluebig.fd11b2e1.svg";